export const COGNITO_USERPOOL_ID = import.meta.env.VITE_COGNITO_USERPOOL_ID;
export const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
export const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
export const COGNITO_REDIRECT_URL = import.meta.env.VITE_COGNITO_REDIRECT_URL;
export const APS_DELIVERY_BACKEND_URL = import.meta.env
  .VITE_APS_DELIVERY_BACKEND_URL;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const VERSION = import.meta.env.VITE_VERSION;
